// extracted by mini-css-extract-plugin
export default {"container":"comment_container__swTxx","comment":"comment_comment__luPTr","icon":"comment_icon__VcTt0"};